'use strict'

module.exports = '/mplex/6.7.0'
